import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { GenericModal } from '../GenericModal/index.js';
import LoginBox from './LoginBox.js';
import { FAIcon } from '../fa-icon/component.js';

var LoginLink = function LoginLink(_ref) {
  var authCapabilities = _ref.authCapabilities,
      authUrls = _ref.authUrls,
      css_class = _ref.css_class,
      hideLogin = _ref.hideLogin,
      icon = _ref.icon,
      idProvidersUrl = _ref.idProvidersUrl,
      login_text = _ref.login_text,
      name = _ref.name,
      onLoginLoad = _ref.onLoginLoad,
      socialIcon = _ref.socialIcon;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var open = function open(e) {
    setShowModal(true);
    e.preventDefault();
  };

  var close = function close() {
    setShowModal(false);
  };

  var linkContent = function linkContent() {
    var css = (css_class || '') + 'btn btn-primary btn-primary-branded capitalize';

    if (icon) {
      return /*#__PURE__*/React.createElement("a", {
        onClick: open,
        className: css,
        href: "#"
      }, /*#__PURE__*/React.createElement(FAIcon, {
        icon: icon
      }), " ", name);
    } else {
      return /*#__PURE__*/React.createElement("a", {
        onClick: open,
        className: css,
        href: "#"
      }, name);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "login-link"
  }, !hideLogin && linkContent(), showModal &&
  /*#__PURE__*/

  /* @ts-ignore */
  React.createElement(GenericModal, {
    onClose: close,
    modalClass: "login-reg-modal",
    canClose: true
  }, /*#__PURE__*/React.createElement(LoginBox, {
    loginText: login_text,
    idProvidersUrl: idProvidersUrl,
    authCaps: authCapabilities,
    authUrls: authUrls,
    socialIcon: socialIcon,
    onLoginLoad: onLoginLoad
  })));
};

LoginLink.displayName = "LoginLink";
export { LoginLink as default };